import React, { useContext, useEffect } from 'react';
import AgendaStreamingContextProvider from '../../common/AgendaStreamingContextProvider';
import FavoritesContextProvider from '../../common/FavoritesContextProvider';
import GoUpBtn from '../../common/GoUpBtn';
import GoUpParag from '../../common/GoUpParag';
import Loader from '../../common/Loader';
import MainContext from '../../contexts/MainContext';
import { useFetchSeoSettings } from '../../data/fetchSeoSettings';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useHandleSeoSettings } from '../../data/seo/seoUtils';
import { classIf, getConfiguration } from '../../data/utils';
import { getLabel } from '../../data/labels';
import LiveSection from '../../live/common/LiveSection';
import { PageDataContext } from '../../PageData';
import { setAvailableSpaceForTables } from '../../tables-utils';
import { useLayout, useUISettings, useUISettingsDispatch } from '../../UISettingsProvider';
import Carousel from './Carousel';
import Widgets from './Widgets';
import { useFetch } from '../../data/fetch/useFetch';
import { parseWidgetData } from '../../data/parseWidgetData';
import PrematchHomeVideoNews from '../prematch-home/prematch-home-video/PrematchHomeVideoNews';
import LiveScoresDisclaimer from '../../live/common/LiveScoresDisclaimer';
import XPromoPanel from './XPromoPanel';

function handleClick() {
    window.openSection('live-suite');
}

function TopMatch(props) {
    const conf = getConfiguration();
    const cfgSeo = conf.seo;
    const mainContext = useContext(MainContext);
    const uiSettings = useUISettings();
    const layout = useLayout();
    const dispatch = useUISettingsDispatch();
    const seoContext = React.useContext(SeoContext);
    const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
        parseWidgetData(data, false),!window.appConfig?.SHOP_MODE
    );
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname, false, cfgSeo && mainContext.currentSection.current === 'top-match' && !props.openFromPath);

    useHandleSeoSettings(seoSettingsState);

    let showWidgets = true;
    if (!isLoading && !isError) {
        if (data == null || (data.topMatches == null && data.lastMinute == null && data.soffiata == null)) {
            showWidgets = false;
        }
    }

    const pageDataContext = React.useContext(PageDataContext);
    const pageData = pageDataContext;
	const prematchHomeVideoList = (conf?.phvn?.length > 0 && conf?.phvn.filter((p)=> {return (p.cntnrd || null) != null}).length == 0 )? conf.phvn : []; // If conf.phvn.cntnrd is set (e.g. cntnrd=='betslip' ), will be showed in the appropriate container
    useEffect(() => {
		dispatch({
            type: 'setFullscreen',
            isFullScreen: false
        });
    }, []);

	useEffect(() => {
		setAvailableSpaceForTables();
    }, [uiSettings]);

    return (
        <>
            <SeoMetaTags />
            <div className={"griglia-centrale-sport col stringimento-sidebar top-match " + layout.order.divCentrale} id="div-centrale">
                <div className="contenitore-schedine-sport">
                    <div className={"competizione-interna" + classIf(showWidgets, ' dueColonne dueColonne_Template_1') + classIf(uiSettings.fullScreen, 'unaColonna')}>
                        <div id="primo-blocco-sport" className={"sport-blocco primo-blocco-sport go-up-arrow-on-overflow" + classIf(uiSettings.fullScreen, 'no-margin')}>
                            <GoUpBtn />
                            {pageData != null &&
                                <>
                                    {conf.sxpp?
                                        <XPromoPanel />
                                    :
                                        pageData.carouselBanners?.length > 0 &&
                                        <Carousel banners={pageData.carouselBanners} />
                                    }
                                    {!window.appConfig.SHOP_MODE && (
                                        <div className="icone-sport-centrale">
                                            <div className="row intemporeale-sport bg-nero bianco">
                                                <div className="col left" onClick={() => window.openSection("live-suite")}>
                                                    <span className="margine-dx-mezzo">{getLabel('prematch_page.carousel.real_time_part1')}
                                                        <span className="colore-1 margine-sx-mezzo">{getLabel('prematch_page.carousel.real_time_part2')}</span>
                                                    </span>
                                                    <a href="#!">{pageData.liveMatches} <i className="fas fa-chevron-right freccia-hover" onClick={handleClick} ></i></a>
                                                </div>
                                                <div className="col day-win maiuscolo">
                                                    <div className="vincita-giorno">
                                                        <i className="fas fa-calendar-day margine-dx-mezzo"></i>{getLabel('prematch_page.carousel.day_win')}
                                                        <span className="grassetto colore-1 margine-sx-mezzo">{pageData.dailyWinnings}</span>
                                                    </div>
                                                    <span className="trattino">|</span>
                                                    <div className="vincita-giorno">
                                                        <i className="fas fa-calendar-week margine-dx-mezzo"></i>{getLabel('prematch_page.carousel.week_win')}
                                                        <span className="grassetto colore-1 margine-sx-mezzo">{pageData.weeklyWinnings}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            }
                            {!window.appConfig.SHOP_MODE &&
                                <>
                                    <div className="competizione-sport" id="competizione-1">
                                        <div className="macro-gruppi"></div>
                                        <FavoritesContextProvider>
                                            <AgendaStreamingContextProvider>
                                                <LiveSection openMatch={props.openMatchLive} isLiveSuite={false} moreBetsEnabled={false} />
                                                <LiveScoresDisclaimer />
                                            </AgendaStreamingContextProvider>
                                        </FavoritesContextProvider>
                                    </div>
                                    <SeoMainContainer />
                                    <GoUpParag/>
                                </>
                            }
                        </div>
                        {isError &&
                            <Loader error={isError} />
                        }
                        {!isLoading &&
                            (prematchHomeVideoList.length > 0?
                                <PrematchHomeVideoNews streamingList={prematchHomeVideoList} />
                            :
                                showWidgets ? <Widgets data={data} /> : null
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default TopMatch;